import * as R from 'ramda';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import middlewares from './middlewares';
import reducers from './reducers';
export default (state, history, createReducers = () => ({}), createMiddlewares = () => ([]), epics = []) => {
    return createStore(combineReducers(reducers(history, createReducers)), state, compose(applyMiddleware(...middlewares(state, history, createMiddlewares, epics)), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : R.identity));
};
